import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import {Router} from "@angular/router";
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import { DatePipe } from '@angular/common';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-unpaid-invoice-form',
  templateUrl: './unpaid-invoice-form.component.html',
  styleUrls: ['./unpaid-invoice-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
 ],
})
export class UnpaidInvoiceFormComponent implements OnInit {
  saveSuccess: boolean;
  saveUnsuccess: boolean;

  unpaidInvoces:any=[];
  invoiceDetails:any=[];
  paid_status:any;
  unpaidInvoice: FormGroup;
  loggedUserInfo:any=[]
  slips:any=[];
  payments:any=[];
  data:any;
  constructor(private datePipe: DatePipe, private observables:ObservablesService,private formBuilder: FormBuilder,private api:ApiService,private router: Router) {
    if(this.router.getCurrentNavigation().extras.state !== undefined){
      this.invoiceDetails = this.router.getCurrentNavigation().extras.state.data
      this.getPayments()
    }
  }
  ngOnInit() {
    this.api.getLoggedUserInfo().then((res:any)=>{
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
      }else{
        this.api.logOut()
      }
    })
    this.getSlips(this.invoiceDetails);
    // console.log(this.invoiceDetails);
    if(this.invoiceDetails.paid_status){
      this.unpaidInvoice = this.formBuilder.group({
        master_invoice_id:[this.invoiceDetails.id],
        invoice_id:[this.invoiceDetails.invoice_id],
        invoice_number:[this.invoiceDetails.invoice_number,Validators.required],
        invoice_date:[{value:this.invoiceDetails.invoice_date,disabled:true},Validators.required],
        paid_amt:[this.invoiceDetails.paid_amt.toFixed(2),Validators.required],
        balance:[this.invoiceDetails.balance.toFixed(2),Validators.required],
        total_amt:[this.invoiceDetails.total_amount.toFixed(2),Validators.required],
        now_paying:[0,Validators.required],
        reference_id:[''],
        paid_date:[{value:moment(),disabled:true},Validators.required],
        mode_of_payment:['CASH'],
        comments:[null],
        reduce_status:[true]
      });
    }else{

      this.unpaidInvoice = this.formBuilder.group({
        master_invoice_id:[this.invoiceDetails.id],
        invoice_id:[this.invoiceDetails.invoice_id],
        invoice_number:[this.invoiceDetails.invoice_number,Validators.required],
        invoice_date:[{value:this.invoiceDetails.invoice_date,disabled:true},Validators.required],
        paid_amt:[this.invoiceDetails.paid_amt,Validators.required],
        balance:[this.invoiceDetails.balance,Validators.required],
        total_amt:[this.invoiceDetails.total_amount,Validators.required],
        now_paying:[0,Validators.required],
        paid_date:[{value:moment(),disabled:true},Validators.required],
        reference_id:[''],
        mode_of_payment:['CASH',Validators.required],
        comments:[null],
        reduce_status:[false]
      });
    }
    //this.getItem();
  }

  getPayments(){
    this.api.send("findDb",{
      table:"payments",
      conditions:[{'master_invoice_id':this.invoiceDetails.id}]
    }).then((res:any)=>{
      this.payments = res.data;
    })
  }

  fullPaidChanged(event){
    // console.log("value changed=",event)
    if(event.checked){
      let data = { target:{value:this.invoiceDetails.balance}};
      this.calculateBalance(data)

    }else{
      let data = { target:{value:'00'}};
      this.calculateBalance(data)
    }
  }

  getSlips(invoiceData){
    this.api.send("findDb",{
      table:"master_slips",
      conditions:[{
        "master_invoice_id":invoiceData.id
      }]
    }).then((res:any)=>{
      // console.log("result=",res);
      if(res.data.length > 0){
        this.slips = res.data;
      }
    })
  }

  viewSlip(slip){
    // this.observables.showSlipViewStatus.next({id:slip.id,invoiceStatus:false})
    this.observables.showSlipViewStatus.next({id:slip.id,invoiceStatus:false})
  }

  toggleChanged(event){
    // console.log("toggle changed=",event)
    if(event.checked){
      this.unpaidInvoice.patchValue({reduce_status:true})

      this.unpaidInvoice.get('mode_of_payment').clearValidators();
      this.unpaidInvoice.get('now_paying').clearValidators();
      this.unpaidInvoice.get('mode_of_payment').updateValueAndValidity();
      this.unpaidInvoice.get('now_paying').updateValueAndValidity();
    }else{
      this.unpaidInvoice.patchValue({reduce_status:false,
          paid_amt:this.invoiceDetails.paid_amt,
          balance:this.invoiceDetails.balance,
          now_paying:0})
          this.unpaidInvoice.patchValue({'mode_of_payment':'CASH'})
          this.unpaidInvoice.get('mode_of_payment').setValidators([Validators.required]);
          this.unpaidInvoice.get('mode_of_payment').updateValueAndValidity();
          this.unpaidInvoice.get('now_paying').setValidators([Validators.required]);
          this.unpaidInvoice.get('now_paying').updateValueAndValidity();
    }
  }

  cancel(){
    this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
  }

  submitData(value){
    value = this.unpaidInvoice.getRawValue()
    // console.log("form data",value)
    let date:any = new Date(value.paid_date);
    let paid_date:any=this.datePipe.transform(date, 'yyyy-MM-dd');
    // console.log("paid_date",paid_date)
    // let date:any = new Date(value.invoice_date);
    // let slip_date:any = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();


    this.api.send("updateDb",{
      table:'master_invoices',
      data:{
        paid_status:(value.paid_amt==value.total_amt)?1:0,
        paid_amt:value.paid_amt,
        balance:value.balance
      },
      conditions:[{id:value.master_invoice_id}]
    }).then((result:any)=>{
      if(result.data.affectedRows){

        this.api.send("insertDb",{
          table:"payments",
          data:{
            master_invoice_id:value.master_invoice_id,
            amount:value.now_paying,
            mode_of_payment:value.mode_of_payment,
            reference_id: value.reference_id,
            paid_date:paid_date,
            action_status:(value.reduce_status)?'Credit/Paid':'Debit/Received',
            comments:value.comments
          }
        }).then((result1:any)=>{
          if(result1.data.affectedRows){
            this.unpaidInvoice.reset();
            this.saveSuccess = true;
            this.saveUnsuccess = false;
            this.observables.showToastMessage({type:0, message:"Invoice saved Successfully"})
            this.router.navigate([this.api.getRoute(this.loggedUserInfo.level,'/dashboard')])
            // this.observables.gotoHomeStatus.next()
          }else{
            this.saveSuccess = false;
            this.saveUnsuccess = true;
          }
        })

    }
  })

}
  calculateBalance(event){
    // console.log("entered amount= : ",event.target.value);
    // console.log("balance=",this.unpaidInvoice.get('balance').value);
    if(!this.unpaidInvoice.get('reduce_status').value){

      if(event.target.value == '' || event.target.value == '00'){
        // event.target.value = 0;
        this.unpaidInvoice.patchValue({'now_paying':0})
      }else if(event.target.value >= this.invoiceDetails.balance){
        // event.target.value = this.invoiceDetails.balance
        this.unpaidInvoice.patchValue({'now_paying':this.invoiceDetails.balance})
      }else{
        event.target.value = event.target.value.replace(/^0+/, '')
      }

      let entered_amount=parseFloat(event.target.value);
      let balance=parseFloat(this.invoiceDetails.balance);
      let available=balance-entered_amount;

      let paid_amt=parseFloat(this.invoiceDetails.paid_amt);
      let total_paid=paid_amt+entered_amount;
      this.unpaidInvoice.patchValue({'balance':available.toFixed(2)})
      this.unpaidInvoice.patchValue({'paid_amt':total_paid.toFixed(2)})
    }else{
      if(event.target.value == ''){
        // event.target.value = 0;
        this.unpaidInvoice.patchValue({'now_paying':0})
      }else if(event.target.value > this.invoiceDetails.paid_amt){
        // event.target.value = this.invoiceDetails.paid_amt
        this.unpaidInvoice.patchValue({'now_paying':this.invoiceDetails.paid_amt})
      }else{
        event.target.value = event.target.value.replace(/^0+/, '')
      }

      let entered_amount=parseFloat(event.target.value);
      let balance=parseFloat(this.invoiceDetails.balance);
      let available=balance+entered_amount;

      let paid_amt=parseFloat(this.invoiceDetails.paid_amt);
      let total_paid=paid_amt-entered_amount;
      this.unpaidInvoice.patchValue({'balance':available.toFixed(2)})
      this.unpaidInvoice.patchValue({'paid_amt':total_paid.toFixed(2)})
    }

  }

}
